import { render, staticRenderFns } from "./ProgressComponents.vue?vue&type=template&id=8aac630e&lang=pug&"
import script from "./ProgressComponents.vue?vue&type=script&lang=ts&"
export * from "./ProgressComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports